import { defineMessages, useIntl } from 'react-intl';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { designTokens } from '@commercetools-uikit/design-system';
import { warning } from '@commercetools-uikit/utils';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import { css } from '@emotion/react';
import { CloseIcon, CloseBoldIcon, CaretDownIcon, SearchIcon } from '@commercetools-uikit/icons';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import omit from 'lodash/omit';
import AccessibleButton from '@commercetools-uikit/accessible-button';
import { components } from 'react-select';
import { cloneElement } from 'react';
import Spacings from '@commercetools-uikit/spacings';
import Text from '@commercetools-uikit/text';

var messages$1 = defineMessages({
  clearButtonLabel: {
    id: 'UIKit.ClearButton.clearButtonLabel',
    description: 'Label for the clear button',
    defaultMessage: 'Clear'
  }
});

const _excluded = ["ref", "onMouseDown"];
function ownKeys$6(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$6(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$6(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const ClearIndicator = props => {
  const intl = useIntl();
  const getStyles = props.getStyles,
    _props$innerProps = props.innerProps,
    ref = _props$innerProps.ref,
    onMouseDown = _props$innerProps.onMouseDown,
    restInnerProps = _objectWithoutProperties(_props$innerProps, _excluded),
    selectProps = props.selectProps;
  return jsx("button", _objectSpread$6(_objectSpread$6({}, restInnerProps), {}, {
    ref: ref,
    css: /*#__PURE__*/css("border:none;cursor:pointer;background:none;box-sizing:border-box;text-decoration:none;fill:", designTokens.colorNeutral40, ";:hover svg *{fill:", designTokens.colorError, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:ClearIndicator;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    style: getStyles('clearIndicator', props),
    title: intl.formatMessage(messages$1.clearButtonLabel),
    "aria-label": intl.formatMessage(messages$1.clearButtonLabel)
    // overriding the default `aria-hidden` prop value to make the component accessible by keyboard - https://github.com/JedWatson/react-select/issues/4793
    ,
    "aria-hidden": false
    // only onMouseDown and onTouchEnd event handlers are passed by `react-select` to the component by default, which makes it not accessible by keyboard
    ,
    onClick: onMouseDown,
    children: jsx(CloseIcon, {
      size: selectProps.isCondensed ? 'small' : 'medium'
    })
  }));
};
ClearIndicator.displayName = 'ClearIndicator';
var ClearIndicator$1 = ClearIndicator;

function ownKeys$5(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$5(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$5(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
// see https://github.com/JedWatson/react-select/blob/44e9fb29b230e49a754a2f0d6f30c2250aa45009/src/components/MultiValue.js
const removeProps = ['onClick', 'onTouchEnd', 'onMouseDown'];
const TagRemove = props => {
  const isDisabled = Boolean(props.selectProps.isDisabled || props.selectProps.isReadOnly);
  // when the select input is disabled,
  // we don't want to spread the removeProp event handlers
  const innerProps = isDisabled ? omit(props.innerProps, removeProps) : props.innerProps;
  return jsx(AccessibleButton, _objectSpread$5(_objectSpread$5({
    label: "Remove"
  }, innerProps), {}, {
    children: jsx(CloseBoldIcon, {
      color: isDisabled ? 'neutral60' : 'solid',
      size: props.selectProps.isCondensed ? 'small' : 'medium'
    })
  }));
};
TagRemove.displayName = 'TagRemove';
var TagRemove$1 = TagRemove;

function ownKeys$4(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$4(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$4(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const DropdownIndicator = props => jsx(components.DropdownIndicator, _objectSpread$4(_objectSpread$4({}, props), {}, {
  children: jsx(CaretDownIcon, {
    color: props.isDisabled ? 'neutral60' : undefined,
    size: "small"
  })
}));
DropdownIndicator.displayName = 'DropdownIndicator';
var DropdownIndicator$1 = DropdownIndicator;

function ownKeys$3(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$3(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$3(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const SearchIconDropdownIndicator = props => {
  return jsx(components.DropdownIndicator, _objectSpread$3(_objectSpread$3({}, props), {}, {
    children: jsx(SearchIcon, {
      color: 'neutral60',
      size: props.selectProps.isCondensed ? 'medium' : 'big'
    })
  }));
};
SearchIconDropdownIndicator.displayName = 'SearchIconDropdownIndicator';
var SearchIconDropdownIndicator$1 = SearchIconDropdownIndicator;

function ownKeys$2(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$2(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$2(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const getDefaultComponent = type => {
  if (type === 'singleValue') return components.SingleValue;
  if (type === 'placeholder') return components.Placeholder;
  return null;
};
const WrapperWithIcon = props => {
  const DefaultComponent = getDefaultComponent(props.type);
  if (!DefaultComponent) {
    return null;
  }
  return jsxs(Fragment, {
    children: [props.selectProps.iconLeft && /*#__PURE__*/cloneElement(props.selectProps.iconLeft, {
      size: props.selectProps.isCondensed ? 'medium' : 'big'
    }), jsx("span", {
      // react-select uses absolute positioning for the SingleValue/Placeholder
      // the icon has a fixed size of 24px (== SpacingsXl), therefore we can use a fixed margin
      // spacingsXs is the margin between the icon and value
      css: /*#__PURE__*/css("margin-left:", designTokens.spacing20, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:WrapperWithIcon;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
      children: jsx(DefaultComponent, _objectSpread$2({}, props))
    })]
  });
};
WrapperWithIcon.displayName = 'WrapperWithIcon';
var WrapperWithIcon$1 = WrapperWithIcon;
const customComponents = {
  SingleValue: props => jsx(WrapperWithIcon, _objectSpread$2(_objectSpread$2({}, props), {}, {
    type: "singleValue"
  })),
  Placeholder: props => jsx(WrapperWithIcon, _objectSpread$2(_objectSpread$2({}, props), {}, {
    type: "placeholder"
  }))
};

const NO_VALUE_FALLBACK = '- - - -';
const SELECT_DROPDOWN_OPTION_TYPES = {
  SINGLE_PROPERTY: 'single-property',
  DOUBLE_PROPERTY: 'double-property',
  MULTIPLE_PROPERTIES: 'multiple-properties'
};

function ownKeys$1(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys$1(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys$1(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const MultiplePropertiesSelectInputOption = props => {
  const data = props.data;
  const noValueFallback = props.noValueFallback || NO_VALUE_FALLBACK;
  return jsx(components.Option, _objectSpread$1(_objectSpread$1({}, props), {}, {
    children: jsxs(Spacings.Stack, {
      scale: "xs",
      children: [jsx(Text.Detail, {
        fontWeight: "bold",
        children: (data === null || data === void 0 ? void 0 : data.label) || noValueFallback
      }), jsxs(Text.Detail, {
        children: ["Key: ", (data === null || data === void 0 ? void 0 : data.key) || noValueFallback]
      }), jsxs(Text.Detail, {
        children: ["ID: ", (data === null || data === void 0 ? void 0 : data.id) || noValueFallback]
      })]
    })
  }));
};
MultiplePropertiesSelectInputOption.displayName = 'MultiplePropertiesSelectInputOption';
const DoublePropertySelectInputOption = props => {
  const data = props.data;
  const noValueFallback = props.noValueFallback || NO_VALUE_FALLBACK;
  return jsx(components.Option, _objectSpread$1(_objectSpread$1({}, props), {}, {
    children: jsxs(Spacings.Stack, {
      scale: "xs",
      children: [jsx(Text.Detail, {
        fontWeight: "bold",
        children: (data === null || data === void 0 ? void 0 : data.label) || noValueFallback
      }), jsxs(Text.Detail, {
        children: ["Key: ", (data === null || data === void 0 ? void 0 : data.key) || noValueFallback]
      })]
    })
  }));
};
DoublePropertySelectInputOption.displayName = 'DoublePropertySelectInputOption';
const CustomSelectInputOption = props => {
  var _props$optionInnerPro;
  const noValueFallback = props.noValueFallback || NO_VALUE_FALLBACK;
  switch (props.optionType) {
    case SELECT_DROPDOWN_OPTION_TYPES.MULTIPLE_PROPERTIES:
      return jsx(MultiplePropertiesSelectInputOption, _objectSpread$1(_objectSpread$1({}, props.optionInnerProps), {}, {
        noValueFallback: noValueFallback
      }));
    case SELECT_DROPDOWN_OPTION_TYPES.DOUBLE_PROPERTY:
      return jsx(DoublePropertySelectInputOption, _objectSpread$1(_objectSpread$1({}, props.optionInnerProps), {}, {
        noValueFallback: noValueFallback
      }));
    default:
      return jsx(components.Option, _objectSpread$1(_objectSpread$1({}, props.optionInnerProps), {}, {
        children: jsx(Text.Detail, {
          children: ((_props$optionInnerPro = props.optionInnerProps.data) === null || _props$optionInnerPro === void 0 ? void 0 : _props$optionInnerPro.label) || noValueFallback
        })
      }));
  }
};
CustomSelectInputOption.displayName = 'CustomSelectInputOption';

var messages = defineMessages({
  createLabel: {
    id: 'UIKit.CreatableSelectInput.createLabel',
    description: 'Text of dropdown when creating option',
    defaultMessage: 'Create "{inputValue}"'
  },
  noOptionsMessageWithInputValue: {
    id: 'UIKit.SelectInput.noOptionsMessageWithInputValue',
    description: 'Text of dropdown when no options match search text',
    defaultMessage: 'No options'
  },
  noOptionsMessageWithoutInputValue: {
    id: 'UIKit.SelectInput.noOptionsMessageWithoutInputValue',
    description: 'Text of dropdown when no options exist',
    defaultMessage: 'No options'
  },
  placeholder: {
    id: 'UIKit.SelectInput.placeholder',
    description: 'Default input placeholder text',
    defaultMessage: 'Select...'
  },
  loadingOptions: {
    id: 'UIKit.SelectInput.loadingOptions',
    description: 'Default input loading text',
    defaultMessage: 'Loading...'
  }
});

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context11, _context12; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context11 = ownKeys(Object(t), !0)).call(_context11, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context12 = ownKeys(Object(t))).call(_context12, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const getHorizontalConstraintValue = value => {
  switch (value) {
    case 'auto':
      return 'initial';
    default:
      return designTokens["constraint".concat(value)] || designTokens.constraintScale;
  }
};
const getInputBackgroundColor = props => {
  if (props.appearance === 'quiet') {
    return designTokens.colorTransparent;
  }
  if (props.isDisabled) {
    return designTokens.backgroundColorForInputWhenDisabled;
  }
  if (props.isReadOnly) {
    return designTokens.backgroundColorForInputWhenReadonly;
  }
  return designTokens.backgroundColorForInput;
};
const getMultiValueBackgroundColor = props => {
  if (props.isDisabled) return designTokens.backgroundColorForInputWhenDisabled;
  if (props.isReadOnly) return designTokens.backgroundColorForInputWhenReadonly;
  return designTokens.colorPrimary95;
};
const getInputBorderColor = (props, state) => {
  if (props.appearance === 'quiet') {
    return designTokens.colorTransparent;
  }
  if (props.isDisabled) {
    return designTokens.borderColorForInputWhenDisabled;
  }
  if (props.isReadOnly) {
    return designTokens.colorNeutral95;
  }
  if (state.isFocused) {
    return designTokens.borderColorForInputWhenFocused;
  }
  if (props.hasError) {
    return designTokens.borderColorForInputWhenError;
  }
  if (props.hasWarning) {
    return designTokens.borderColorForInputWhenWarning;
  }
  return designTokens.borderColorForInput;
};
const getHoverInputBorderColor = props => {
  if (props.appearance === 'quiet') {
    return designTokens.colorTransparent;
  }
  if (props.isDisabled) {
    return designTokens.borderColorForInputWhenDisabled;
  }
  if (props.isReadOnly) {
    return designTokens.colorNeutral95;
  }
  if (props.hasError) {
    return designTokens.borderColorForInputWhenError;
  }
  if (props.hasWarning) {
    return designTokens.borderColorForInputWhenWarning;
  }
  return designTokens.borderColorForInputWhenHovered;
};
const getHoverInputBackgroundColor = props => {
  if (!props.isDisabled && !props.isReadOnly) {
    if (props.appearance === 'quiet') {
      return 'hsla(240, 64%, 58%, 4%)'; //this is mainly a combination of our primary color hsl(240, 64%, 58%) and an alpha channel of 4%.
    } else {
      return designTokens.backgroundColorForInputWhenHovered;
    }
  }
  return null;
};
const controlStyles = props => (base, state) => {
  var _context;
  return _objectSpread(_objectSpread(_objectSpread({}, base), {}, {
    fontSize: props.isCondensed ? designTokens.fontSize20 : designTokens.fontSize30,
    backgroundColor: getInputBackgroundColor(props),
    borderColor: getInputBorderColor(props, state),
    borderWidth: (() => {
      if (props.hasWarning || props.hasError || state.isFocused || props.appearance === 'quiet') {
        return designTokens.borderWidth2;
      }
      return designTokens.borderWidth1;
    })(),
    borderRadius: designTokens.borderRadiusForInput,
    minHeight: props.isCondensed ? designTokens.heightForInputAsSmall : designTokens.heightForInput,
    cursor: (() => {
      if (props.isDisabled) return 'not-allowed';
      if (props.isReadOnly) return 'default';
      return 'pointer';
    })(),
    padding: props.appearance === 'quiet' ? "0 ".concat(designTokens.spacing20) : "0 ".concat(designTokens.spacing30),
    transition: _concatInstanceProperty(_context = "border-color ".concat(designTokens.transitionStandard, ",\n    box-shadow ")).call(_context, designTokens.transitionStandard),
    outline: 0,
    boxShadow: 'none'
  }, props.horizontalConstraint === 'auto' ? {
    display: 'inline-flex'
  } : {}), {}, {
    '&:focus-within': {
      borderColor: (() => {
        if (!props.isDisabled && !props.isReadOnly) return designTokens.borderColorForInputWhenFocused;
        return null;
      })()
    },
    '&:hover': {
      borderColor: getHoverInputBorderColor(props),
      backgroundColor: getHoverInputBackgroundColor(props)
    },
    pointerEvents: 'auto',
    color: props.isDisabled || props.isReadOnly ? designTokens.fontColorForInputWhenDisabled : base.fontColorForInput
  });
};
const menuStyles = props => base => {
  return _objectSpread(_objectSpread({}, base), {}, {
    border: "1px solid ".concat(designTokens.colorSurface),
    borderRadius: designTokens.borderRadiusForInput,
    backgroundColor: designTokens.backgroundColorForInput,
    boxShadow: '0 2px 5px 0px rgba(0, 0, 0, 0.15)',
    fontSize: designTokens.fontSize30,
    fontFamily: 'inherit',
    margin: "".concat(designTokens.spacing10, " 0 0 0"),
    borderColor: (() => {
      if (props.hasError || props.hasWarning) {
        return designTokens.colorSurface;
      }
      return base.borderColorForInput;
    })(),
    width: props.horizontalConstraint === 'auto' ? 'auto' : '100%',
    minWidth: props.minMenuWidth ? getHorizontalConstraintValue(props.minMenuWidth) : designTokens.constraint3,
    maxWidth: props.maxMenuWidth ? getHorizontalConstraintValue(props.maxMenuWidth) : designTokens.constraintScale
  });
};
const indicatorSeparatorStyles = () => base => {
  return _objectSpread(_objectSpread({}, base), {}, {
    display: 'none',
    margin: '0',
    padding: '0',
    marginLeft: designTokens.spacing10
  });
};
const dropdownIndicatorStyles = props => base => {
  return _objectSpread(_objectSpread({}, base), {}, {
    color: designTokens.fontColorForInput,
    margin: '0',
    padding: '0',
    marginLeft: designTokens.spacing20,
    fill: (() => {
      if (props.isDisabled || props.isReadOnly) return designTokens.fontColorForInputWhenDisabled;
      if (props.hasError) return designTokens.colorError;
      if (props.hasWarning) return designTokens.colorWarning;
      return designTokens.colorNeutral60;
    })()
  });
};
const clearIndicatorStyles = () => base => _objectSpread(_objectSpread({}, base), {}, {
  display: 'flex',
  padding: 0,
  marginLeft: designTokens.spacing20
});
const menuListStyles = () => base => {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: "".concat(designTokens.spacing10, " 0"),
    borderRadius: designTokens.borderRadiusForInput,
    backgroundColor: designTokens.backgroundColorForInput
  });
};
const optionStyles = props => (base, state) => {
  var _context2, _context3, _context4;
  return _objectSpread(_objectSpread({}, base), {}, {
    transition: _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "border-color ".concat(designTokens.transitionStandard, ",\n      background-color ")).call(_context3, designTokens.transitionStandard, ",\n      color ")).call(_context2, designTokens.transitionStandard),
    padding: _concatInstanceProperty(_context4 = "".concat(designTokens.spacing20, " ")).call(_context4, designTokens.spacing30),
    lineHeight: designTokens.lineHeight40,
    fontSize: props.isCondensed ? designTokens.fontSize20 : designTokens.fontSize30,
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    color: (() => {
      if (state.isDisabled) return designTokens.fontColorForInputWhenDisabled;
      return designTokens.fontColorForInput;
    })(),
    backgroundColor: (() => {
      if (state.isSelected) return designTokens.colorPrimary95;
      if (state.isFocused) return designTokens.backgroundColorForInputWhenHovered;
      return base.backgroundColor;
    })(),
    '&:active': {
      backgroundColor: (() => {
        if (state.isDisabled) return designTokens.colorTransparent;
        return designTokens.colorPrimary95;
      })()
    }
  });
};
const placeholderStyles = props => base => {
  return _objectSpread(_objectSpread({}, base), {}, {
    color: (() => {
      if (props.appearance === 'quiet' && !props.isReadOnly && !props.isDisabled) {
        if (props.hasError) {
          return designTokens.colorError;
        }
        if (props.hasWarning) {
          return designTokens.colorWarning;
        }
      }
      return designTokens.colorNeutral60;
    })(),
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fill: props.isDisabled || props.isReadOnly ? designTokens.fontColorForInputWhenDisabled : base.fontColorForInput
  });
};
const valueContainerStyles = props => base => {
  var _props$controlShouldR;
  return _objectSpread(_objectSpread(_objectSpread({}, base), !props.isMulti && {
    flexWrap: 'nowrap'
  }), {}, {
    padding: '0',
    backgroundColor: 'none',
    overflow: 'hidden',
    // Display property should be grid when isMulti and has no value so the Placeholder component is positioned correctly with the Input
    // Display property should be Flex when there is an iconLeft, also when the input has some values when isMulti.
    // See PR from react select for more insight https://github.com/JedWatson/react-select/pull/4833
    display: props.iconLeft && !props.isMulti || props.isMulti && props.hasValue && ((_props$controlShouldR = props.controlShouldRenderValue) !== null && _props$controlShouldR !== void 0 ? _props$controlShouldR : true) ? 'flex' : 'grid',
    fill: props.isDisabled || props.isReadOnly ? designTokens.fontColorForInputWhenDisabled : designTokens.colorNeutral60
  });
};
const singleValueStyles = props => base => {
  return _objectSpread(_objectSpread({}, base), {}, {
    color: (() => {
      if (props.isDisabled) {
        return designTokens.fontColorForInputWhenDisabled;
      }
      if (props.isReadOnly) {
        return designTokens.fontColorForInputWhenReadonly;
      }
      if (props.hasError) return designTokens.colorError;
      if (props.hasWarning) return designTokens.colorWarning;
      return designTokens.fontColorForInput;
    })()
  });
};
const groupStyles = props => base => {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: 0,
    '&:not(:first-of-type)': {
      borderTop: props.showOptionGroupDivider ? "1px solid ".concat(designTokens.colorNeutral90) : base.borderTop
    }
  });
};
const groupHeadingStyles = () => base => {
  var _context5;
  return _objectSpread(_objectSpread({}, base), {}, {
    color: designTokens.fontColorForInputWhenReadonly,
    fontSize: designTokens.fontSize20,
    borderBottom: "1px solid ".concat(designTokens.colorNeutral90),
    textTransform: 'none',
    fontWeight: designTokens.fontWeight500,
    padding: _concatInstanceProperty(_context5 = "".concat(designTokens.spacing20, " ")).call(_context5, designTokens.spacing30),
    '&:empty': {
      padding: 0
    }
  });
};
const containerStyles = () => (base, state) => {
  return _objectSpread(_objectSpread({}, base), {}, {
    fontFamily: 'inherit',
    minHeight: designTokens.heightForInputAsSmall,
    borderRadius: designTokens.borderRadiusForInput,
    borderColor: state.isFocused ? designTokens.borderColorForInputWhenFocused : base.borderColor,
    boxShadow: state.isFocused ? 'none' : base.boxShadow
  });
};
const indicatorsContainerStyles = () => () => ({
  background: 'none',
  display: 'flex',
  alignItems: 'center'
});
const menuPortalStyles = props => base => _objectSpread(_objectSpread({}, base), {}, {
  zIndex: props.menuPortalZIndex
});
const multiValueStyles = props => base => {
  var _context6, _context7;
  return _objectSpread(_objectSpread({}, base), {}, {
    display: 'flex',
    alignItems: 'center',
    height: props.isCondensed ? 'inherit' : '32px',
    backgroundColor: getMultiValueBackgroundColor(props),
    padding: props.isCondensed ? _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = "0 ".concat(designTokens.spacing20, " 0 calc(")).call(_context7, designTokens.spacing05, " + ")).call(_context6, designTokens.spacing10, ")") : designTokens.spacing20,
    border: "1px solid ".concat(designTokens.colorNeutral85),
    borderRadius: designTokens.borderRadius20
  });
};
const multiValueLabelStyles = props => base => {
  var _context8, _context9;
  return _objectSpread(_objectSpread({}, base), {}, {
    fontSize: props.isCondensed ? designTokens.fontSize20 : designTokens.fontSize30,
    lineHeight: props.isCondensed ? designTokens.lineHeight20 : designTokens.lineHeight40,
    color: (() => {
      if (props.isDisabled) return designTokens.fontColorForInputWhenDisabled;
      if (props.isReadOnly) return designTokens.fontColorForInputWhenReadonly;
      return base.color;
    })(),
    padding: _concatInstanceProperty(_context8 = "".concat(props.isCondensed ? '1px' : designTokens.spacing10, " ")).call(_context8, designTokens.spacing20),
    borderRadius: _concatInstanceProperty(_context9 = "".concat(designTokens.borderRadius2, " 0 0 ")).call(_context9, designTokens.borderRadius2),
    border: 'none',
    borderWidth: '1px 0 1px 1px',
    '&:last-child': {
      borderRadius: designTokens.borderRadius2,
      borderWidth: designTokens.borderWidth1
    }
  });
};
const multiValueRemoveStyles = props => (base, state) => {
  var _context10;
  return _objectSpread(_objectSpread({}, base), {}, {
    borderColor: designTokens.colorNeutral,
    padding: "0 ".concat(designTokens.spacing10),
    borderRadius: _concatInstanceProperty(_context10 = "0 ".concat(designTokens.borderRadius2, " ")).call(_context10, designTokens.borderRadius2, " 0"),
    borderStyle: 'none',
    borderWidth: '0',
    pointerEvents: state.isDisabled || props.isReadOnly ? 'none' : base.pointerEvents,
    backgroundColor: designTokens.colorNeutral95,
    'svg *': {
      fill: props.isReadOnly ? designTokens.fontColorForInputWhenReadonly : ''
    },
    '&:hover, &:focus': {
      borderColor: designTokens.colorWarning,
      backgroundColor: designTokens.colorNeutral95,
      'svg *': {
        fill: designTokens.colorError
      }
    }
  });
};
function createSelectStyles(props) {
  return {
    control: controlStyles(props),
    menu: menuStyles(props),
    indicatorSeparator: indicatorSeparatorStyles(),
    dropdownIndicator: dropdownIndicatorStyles(props),
    clearIndicator: clearIndicatorStyles(),
    menuList: menuListStyles(),
    menuPortal: menuPortalStyles(props),
    multiValue: multiValueStyles(props),
    multiValueLabel: multiValueLabelStyles(props),
    multiValueRemove: multiValueRemoveStyles(props),
    indicatorsContainer: indicatorsContainerStyles(),
    option: optionStyles(props),
    placeholder: placeholderStyles(props),
    valueContainer: valueContainerStyles(props),
    singleValue: singleValueStyles(props),
    group: groupStyles(props),
    groupHeading: groupHeadingStyles(),
    container: containerStyles()
  };
}

const getMessage = componentName => "".concat(componentName, ": use `menuPortalZIndex` in conjunction with `menuPortalTarget`");
const warnIfMenuPortalPropsAreMissing = props => {
  if (typeof props.menuPortalZIndex !== 'undefined' && props.menuPortalZIndex !== 1 // 1 is the value passed in default props
  ) {
    process.env.NODE_ENV !== "production" ? warning(props.menuPortalTarget, getMessage(props.componentName)) : void 0;
  }
};

// NOTE: This string will be replaced on build time with the package version.
var version = "19.7.0";

export { ClearIndicator$1 as ClearIndicator, CustomSelectInputOption, DoublePropertySelectInputOption, DropdownIndicator$1 as DropdownIndicator, MultiplePropertiesSelectInputOption, SELECT_DROPDOWN_OPTION_TYPES, SearchIconDropdownIndicator$1 as SearchIconDropdownIndicator, TagRemove$1 as TagRemove, WrapperWithIcon$1 as ValueWrapperWithIcon, createSelectStyles, customComponents as customComponentsWithIcons, messages, version, warnIfMenuPortalPropsAreMissing };
